export {memo} from "./memo";try {
    // @ts-ignore
    memo.displayName = "memo";
    // @ts-ignore
    memo.__docgenInfo = { "description": "", "displayName": "memo", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/memoization/index.ts#memo"] = { docgenInfo: memo.__docgenInfo, name: "memo", path: "src/shared/memoization/index.ts#memo" };
}
catch (__react_docgen_typescript_loader_error) { }